module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN326_852032141.307ba3d4.png";